<template>
  <v-container grid-list-md>
    <v-slide-y-transition mode="out-in">
      <v-flex md8 offset-md2>
        <v-card>
          <v-toolbar flat color="grey lighten-3">
            <v-btn icon @click="close()">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title>Action</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn flat v-if="(this.loggedInUser.securityMask.charAt(parseInt(this.access['ActionStats'])-1) == '1') && actionId" @click="goToStats()">Stats</v-btn>
            <v-btn flat v-if="(this.loggedInUser.securityMask.charAt(parseInt(this.access['ActionNotification'])-1) == '1') && (actionId && action.rspsType!=4)" @click="goToNotifications()">Notifications</v-btn>
          </v-toolbar>
          <v-card-text>
            <v-layout row wrap="">
              <v-flex xs12>
                <v-select :items="users" v-model="action.UserID" label="User" item-value="UserID">
                  <template slot="selection" slot-scope="data">
                    <span class="uppercase">{{ data.item.LastName }}, {{ data.item.FirstName }}</span>
                  </template>
                  <template slot="item" slot-scope="data">
                    <span class="uppercase">{{ data.item.LastName }}, {{ data.item.FirstName }}</span>
                  </template>
                </v-select>
                <v-text-field v-model="action.actionName" label="Action Label"></v-text-field>
                <v-textarea v-model="action.msgText" name="input-7-4" label="Message Text"></v-textarea>
                <div class="dow">
                  <p>Days of Week</p>
                  <v-btn-toggle v-model="daysOfWeek" multiple>
                    <v-btn class='white--text' flat>SUN</v-btn>
                    <v-btn class='white--text' flat>MON</v-btn>
                    <v-btn class='white--text' flat>TUE</v-btn>
                    <v-btn class="white--text" flat>WED</v-btn>
                    <v-btn class="white--text" flat>THU</v-btn>
                    <v-btn class="white--text" flat>FRI</v-btn>
                    <v-btn class="white--text" flat>SAT</v-btn>
                  </v-btn-toggle>
                </div>
                <br>
                <div>
                  <v-dialog
                    ref="dialog"
                    v-model="timeModal"
                    :return-value.sync="action.timeOfDay"
                    persistent
                    lazy
                    full-width
                    width="290px"
                  >
                    <v-text-field slot="activator" v-model="action.timeOfDay" label="Time" readonly></v-text-field>
                    <v-time-picker
                      :allowed-minutes="allowedMinutes"
                      v-if="timeModal"
                      v-model="action.timeOfDay"
                      full-width
                    >
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="timeModal = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.dialog.save(action.timeOfDay)">OK</v-btn>
                    </v-time-picker>
                  </v-dialog>
                </div>
                <v-select
                  :items="responseTypes"
                  v-model="action.rspsType"
                  label="Response Type"
                  item-text="label"
                  item-value="value"
                ></v-select>
                <v-select
                  v-if="action.rspsType!=4" 
                  :items="cascadeOptions"
                  v-model="action.cascadeCount"
                  label="Retry Count"
                ></v-select>
              </v-flex>
              <v-flex xs12 md6></v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions> 
            <v-btn v-if="this.loggedInUser.securityMask.charAt(parseInt(this.access['ActionDelete'])-1) == '1'" flat color="red" @click="dialog = true">Delete</v-btn>
            <v-spacer></v-spacer>
            <v-btn v-if="this.loggedInUser.securityMask.charAt(parseInt(this.access['ActionSave'])-1) == '1'" flat color="blue" @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-slide-y-transition>
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Delete?</v-card-title>
        <v-card-text>Are you sure you want to delete this action?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="deleteAction">Yes</v-btn>
          <v-btn color="green darken-1" flat="flat" @click="dialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import RestService from '../services/RestService';
import * as Sentry from '@sentry/browser';

const service = new RestService();

export default {
  name: 'Action',
  props: {
    actionId: String,
    userId: String
  },
  data() {
    return {
      loggedInUser: {},
      access: {},
      dialog: false,
      title: '',
      action: {},
      users: [],
      cascadeOptions: [],
      responseTypes: [],
      /*
        { label: 'Yes/No', value: '1' },
        { label: 'Yes/No/Text Response', value: '2' },
        { label: 'Text Response', value: '3' },
        { label: 'Info Only', value: '4' }
      ],
      */
      daysOfWeek: [0, 1, 2, 3, 4, 5, 6],
      timeModal: false
    };
  },
  methods: {
    goToStats() {
      this.$router.push('/action/' + this.actionId + '/stats');
    },
    goToNotifications() {
      this.$router.push(
        '/user/' +
          this.action.UserID +
          '/action/' +
          this.actionId +
          '/notifications'
      );
    },
    viewUser(user) {
      console.log(user);
    },
    getAvatarUrl(user) {
      return 'https://api.adorable.io/avatars/282/' + user.UserID;
    },
    viewAllUsers() {
      console.log('asdfasfasf');
      this.$router.push('/users');
    },
    logout() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    },
    getname(user) {
      return user.LastName + ', ' + user.FirstName;
    },
    allowedMinutes: m => m % 15 === 0,
    timeOk() {
      console.log(this.action);
    },
    close() {
      this.$router.push('/');
    },
    deleteAction() {
      service
        .deleteActionById(this.actionId)
        .then(response => {
          this.$router.push('/');
        })
        .catch(e => {
          console.log(e);
          Sentry.captureException(e);
        });
    },
    save() {
      var dow = '';
      for (var i = 0; i < 7; i++) {
        if (this.daysOfWeek.includes(i)) {
          dow += 'Y';
        } else {
          dow += 'N';
        }
      }
      this.action.daysOfWeek = dow;
      if (this.action.timeOfDay.length == 5) {
        this.action.timeOfDay += ':00';
      }
      if (this.action.ActionID) {
        service
          .updateAction(this.action)
          .then(response => {
            this.$router.push('/');
          })
          .catch(e => {
            console.log(e);
            Sentry.captureException(e);
          });
      } else {
        service
          .addAction(this.action)
          .then(response => {
            this.$router.push('/');
          })
          .catch(e => {
            console.log(e);
            Sentry.captureException(e);
          });
      }
    }
  },
  created() {
    this.loggedInUser = this.$store.getters['auth/user'];
    this.access = this.$store.getters['auth/access'];
    if (this.userId) {
      this.action.UserID = this.userId;
    }
    // if actionId is present, then get the current action
    if (this.actionId) {
      service
        .getAction(this.actionId)
        .then(response => {
          if (response.data.body && response.data.body.length > 0) {
            this.action = response.data.body[0];
            this.daysOfWeek = [];
            for (var i = 0; i < 7; i++) {
              if (this.action.daysOfWeek[i] == 'Y') {
                this.daysOfWeek.push(i);
              }
            }
          }
        })
        .catch(e => {
          console.log(e);
          Sentry.captureException(e);
        });
    }

    // get list of users to populate users dropdown
    service
      .getUsersByParent(this.userId)
      .then(response => {
        if (response.data.body.length > 0) {
          this.users = response.data.body;
        }
      })
      .catch(e => {
        console.log(e);
        Sentry.captureException(e);
      });

    // get Response Types
    service
      .getDropdown('RspsType')
      .then(response => {
        console.log(response);
        if (response.data.body && response.data.body.length > 0) {
          for (let i=0; i< response.data.body.length; i++) {
            this.responseTypes.push({'label':response.data.body[i].dropdownName,'value':response.data.body[i].dropdownValue});
          }
        }
      })
      .catch(e => {
        console.log(e);
        Sentry.captureException(e);
      });

    // get the cascade max
    service
      .getDropdown('CascadeMax')
      .then(response => {
        console.log(response);
        if (response.data.body && response.data.body.length > 0) {
          for (let i = 0; i <= response.data.body[0].dropdownValue; i++) {
            this.cascadeOptions.push(i.toString());
          }
        }
      })
      .catch(e => {
        console.log(e);
        Sentry.captureException(e);
      });
  }
};
</script>

<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
  &:first-child {
    margin-left: 0;
  }
}
a {
  color: #42b983;
}
.card {
  background-color: #fff;
}
.status-failed {
  background-color: $color-status-failed;
  border-color: $color-status-failed;
}
.status-inactive {
  background-color: $color-status-inactive;
  border-color: $color-status-inactive;
}
.status-good {
  background-color: $color-status-good;
  border-color: $color-status-good;
}
.action-name {
  overflow: hidden;
}
.card {
  min-height: 120px;
}
p {
  margin-bottom: 10px;
}
.dow {
  .v-input {
    margin-top: 5px;
    color:#ffffff;
  }
  button {
    font-size: 12px;
    min-width: 40px;
    background-color:lighten(#134A9E,4);
  }
}
@media (min-width: 450px) {
  .dow {
    button {
      min-width: 48px;
    }
  }
}
@media (min-width: 525px) {
  .dow {
    button {
      min-width: 60px;
    }
  }
}
</style>
